import {
  GetOutstandingWorkReportQuery,
  GetOutstandingWorkReportQueryVariables,
  useGetOutstandingWorkReportQuery,
} from "generated/graphql";
import { useCallback, useMemo } from "react";

const useGetOutstandingWorkReport = ({
  variables,
}: {
  variables: GetOutstandingWorkReportQueryVariables;
}) => {
  const {
    data: graphqlData,
    error,
    loading,
  } = useGetOutstandingWorkReportQuery({
    variables,
    fetchPolicy: "network-only",
  });

  const data = useMemo(() => graphqlData?.getOutstandingWorkReport ?? null, [graphqlData]);

  const getData = useCallback(({ data }: { data?: GetOutstandingWorkReportQuery }) => {
    return data?.getOutstandingWorkReport ?? null;
  }, []);

  return {
    loading,
    data,
    error,
    getData,
  } as const;
};

export default useGetOutstandingWorkReport;
